import Message from 'shared_components/message';
import { axiosLabAPI } from 'services/axios';
import { API_GET_METHOD } from 'global_config/constant-global';
import WebSocketService from "../../services/websocket/WebSocketService";

async function fetchKPIs(requestDate) {
	let KPIs = [];
	
  try{

    const content = {
			method: API_GET_METHOD,
		 	url: `/dashboard/requesttocheckin?p_request_datetime=${requestDate}`
		}
		// WebSocketService.getClientId()
		const response = await axiosLabAPI(content);	
		const { data } = await response;

		if (data && data.STATUSCODE === 200 && data.RECORDS) {
			KPIs = data.RECORDS;
		  }
  } 
  catch(e) {
    Message.error();
	}
	
  return KPIs;
}

export default fetchKPIs;